import {
  DialogContentText,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  TextField,
  styled,
} from '@mui/material';

export const DialogActions = styled(MuiDialogActions)(() => ({
  //
}));

export const DialogContent = styled(MuiDialogContent)(() => ({
  paddingTop: 0,
}));

export const DialogFieldLabel = styled('div')({
  fontSize: '14px',
  marginTop: '8px',
});

export const DialogPrimaryTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    fontSize: '18px',
  },
});

export const DialogFieldRequired = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
  marginLeft: '3px',
}));

export const DialogContentSubText = styled(DialogContentText)({
  fontSize: '13px',
  marginTop: '8px',
});

export const DialogForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),

  // A role=group row (two inputs under one heading) lays out like a label row.
  '& label, & [role="group"]': {
    alignItems: 'baseline',
    display: 'flex',
    fontSize: 14,

    '& .label': {
      flexBasis: '15%',
      flexShrink: 0,
    },

    '& .required::after': {
      content: '" *"',
      color: theme.palette.error.dark,
    },
  },
}));
